import PropTypes from "prop-types"
import { useApiCallback } from "../hooks/useApiCallback"
import HighlightData from "../components/HighlightData"

const BackendData = ({ apiPath }) => {
  const { data, loading } = useApiCallback(apiPath)
  return <HighlightData data={data} loading={loading} />
}

BackendData.propTypes = {
  apiPath: PropTypes.string
}

export default BackendData
